import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import datetime from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

datetime.extend(relativeTime);

console.log(`Social Proof Widget Loaded`);

const container = document.createElement("div");
document.body.append(container);

ReactDOM.render(<App />, container);

// Animation prototype: https://codepen.io/anon/pen/eQLKaO
